import { render } from "./PartnerCleo.vue?vue&type=template&id=009fbd81"
import script from "./PartnerCleo.vue?vue&type=script&lang=js"
export * from "./PartnerCleo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__